import React from "react";
import Page, { PageProps } from "../Page";
import { ILoginPresenter } from "../../../presenter/authentication/LoginPresenter";
import LoginForm from "../../components/authentication/LoginForm";
import Header from "../../components/Header";
import Title from "antd/es/typography/Title";

export interface Props extends PageProps {}
export interface State extends ILoginPresenter {}

export default class LoginPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      login,
      setUsername,
      setPassword,
      username,
      password,
      loginButtonDisabled,
      loaders
    } = this.state;

    return (
      <Page {...this.props}>
        <Header languagePickerVisible={false} />
        <div className="content-wrapper">
          <Title level={3} style={{ textAlign: "center" }}>
            {translate("pages.device_management")}
          </Title>
          <div className="login-form-wrapper">
            <LoginForm
              translate={translate}
              username={username}
              password={password}
              onChangeUsername={setUsername}
              onChangePassword={setPassword}
              login={login}
              loginButtonDisabled={loginButtonDisabled}
              loading={loaders.loginLoader}
            />
          </div>
        </div>
      </Page>
    );
  }
}
